// Container imports
const {
  ADJUST_FOLLOWING_COUNT,
  ADJUST_POSTS_COUNT
} = require('./actions')

// eslint-disable-next-line complexity
function profileUserStatsReducer(state, { type, payload }) {
  switch (type) {
    case ADJUST_FOLLOWING_COUNT:
      return state.merge({
        followers: state.followers + payload.amount
      })
    case ADJUST_POSTS_COUNT:
      return state.merge({
        posts: state.posts + payload.amount
      })
    default:
      return state
  }
}

module.exports = profileUserStatsReducer
